
<template>
    <div>
        <div class="q-px-md text-h6 q-pt-sm" style="background: #fff !important;"> {{$t("FundInfo.title")}} </div>

        <q-form  @submit="ConfirmTransaction" >
            <Account class="q-pa-md "/>
            <Transactions class="" ref="trans"/>
            <div style="text-align: right;"  class="q-pa-md" >
                <q-btn :label='$t("common.continueBtn")' type="submit" style="background: #ff6666; color: white;"/>
            </div>
        </q-form>

        <q-dialog v-model="ConfirmTransactionModal">
            <q-card style="width: 700px; max-width: 800px; border-radius: 1rem !important; " class="q-py-sm">
                <q-card-section style="font-family: 'Poppins', sans-serif; font-size: 16px; padding-bottom: 0px !important;">
                     <b>{{$t("Buy.title")}}</b>
                </q-card-section>
                
                <q-card-section class="">
                    <!-- <q-chip class="q-mb-md" square size="xl" color="primary"  text-color="white" label="SUBSCRIBE"/> -->
                    <Confirmation
                        :TotalInvestment="TotalTransaction"
                    />
                </q-card-section>
                
                <q-card-actions align="right" style="">
                    <Navigation
                        class="q-px-sm"
                        :ShowCancelButton=true
                        :ShowAddToCartButton=true
                        AddToCartButtonColor="primary"
                        @AddToCartButton="Confirmed()"
                        @CancelButton="Cancel()"
                    />
                </q-card-actions>
            </q-card>    
        </q-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import store from '../store'
import Account from '@/components/AccountDetails'
import Transactions from '@/components/TransactionDetails'
import Confirmation from '@/components/TransactionsConfirmation'
import Navigation from '@/components/NavigationButtons'
import AgentSelection from '@/components/AgentSelection.vue'
export default {
    name : 'SummaryInformation',
    components : {
        Transactions,
        Confirmation,
        Navigation,
        Account,
        AgentSelection
    },
    data() {
        return {
            ConfirmTransactionModal : false,
            StoreStateT : store.state.Transactions,
            StoreStateCD : store.state.CD,
            StoreStateAOD : store.state.AOD,
            StoreStateLogin: store.state.Login,
            TotalTransaction : 0,
            showAgent:false,
            TransactionId : '',         
            IakaunRerouteUrl : process.env.VUE_APP_IAKAUN_REREOUTE_URL    
        }
    },
    computed: {

    },
    methods: {
        ...mapActions([
        "PostTransaction",
        "PostTransaction_Submit",
        "eMISTransactionConfirm",
        "ResubmitPostOnboardingSelf",
        "GetOnboardingSelf",
        "TriggerAccountCreation",
        "triggerLogout"
        ]),
        ConfirmTransaction(){

            if(this.StoreStateT.Transaction.Investment.length>0){
                var tempValu = parseFloat(this.StoreStateT.Transaction.TotalInvestment).toFixed(2)
                tempValu =  tempValu.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "," )

                if(this.$refs.trans.TotalTransaction > this.StoreStateT.Transaction.TotalInvestment){

                    this.$q.dialog({
                        title: "Message",
                        message : "Your total Investment Amount must not more amount of MYR " + tempValu
                    })
                }else if(parseFloat(this.$refs.trans.TotalTransaction) < 1000  ){
                    this.$q.dialog({
                        title: "Message",
                        message : "Your Minimum Total investment have to be more then MYR 1,000.00" 
                    })
                }
                else{
                    this.ConfirmTransactionModal = true
                    this.TotalTransaction = this.$refs.trans.TotalTransaction;
                }
            }else{
                 this.$q.dialog({
                    title: "Error",
                    message : "Sorry, there is no Fund available to add in cart." ,
                    persistent: true
                }).onOk(() => {
                // console.log('OK')
                    this.triggerLogout();
                })
            }
            
            this.$store.dispatch('Logging',{
                appid : '2',
                typeid :'4', 
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' ConfirmTransaction (buy),  this.$refs.trans.TotalTransaction - > '+  this.$refs.trans.TotalTransaction
            });
        },
        Cancel(){
            this.ConfirmTransactionModal = false
        },
        Confirmed:function(){
            this.$q.loading.show({spinnerSize : 50})
        if(this.$route.name ==='AHAM Investment'){
            //this.StoreStateT.AgentDetails_onboard ="R000000"
           // alert('triger repost')
            this.GetOnboardingSelf({
                ApplicationId:this.StoreStateCD.ApplicantId 
            }).then(res =>{
                if(this.StoreStateCD.applicationStatus != 'Processing' ){
                    this.ResubmitPostOnboardingSelf()
                        .then(res =>{
                            this.$store.dispatch('Logging',{
                                appid : '2',
                                typeid :'4', 
                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' ResubmitPostOnboardingSelf (buy),  res - > '+  res
                            });
                            if((res=='true')||(res== true)){
                                 this.GetOnboardingSelf({
                                    ApplicationId:this.StoreStateCD.ApplicantId 
                                })  
                                .then(res =>{
                                    this.$store.dispatch('Logging',{
                                        appid : '2',
                                        typeid :'4', 
                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetOnboardingSelf (buy),  res - > '+  res
                                    });
                                    if((res=='true')||(res==true))
                                    {
                                       /*  this.TriggerAccountCreation().then(res =>{
                                            
                                            this.$store.dispatch('Logging',{
                                                appid : '2',
                                                typeid :'4', 
                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerAccountCreation (buy),  res - > '+  res
                                            });  */                                           
                                            //if(res == true){ 
                                                if((this.TransactionId === 0)||(this.TransactionId==='')){

                                                    this.CreateTempId();
                                                }

                                                this.StoreStateT.AgentDetails ="RZ00000"
                                                this.StoreStateT.AgentDetails_onboard ="RZ00000"
                                                this.StoreStateCD.Account.AccountId = this.StoreStateAOD.OnBoardUTAccountNo
                                                this.CreateFundTransaction_Investment();
                                                this.PostTransaction({
                                                        ApplicationId : this.TransactionId 
                                                    })
                                                    .then(res=>{
                                                        console.log('res 2 ' + res)
                                                        this.$store.dispatch('Logging',{
                                                            appid : '2',
                                                            typeid :'4', 
                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction (buy),  res - > '+  res
                                                        });
                                                        
                                                            if(res!=true){
                                                            this.$q.loading.hide()
                                                            this.$q.dialog({
                                                                title: 'Warning',
                                                                message: res,
                                                            })     
                                                            }else{

                                                                this.eMISTransactionConfirm({
                                                                    DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                                                                }).then(res =>{
                                                                    
                                                                     this.$store.dispatch('Logging',{
                                                                            appid : '2',
                                                                            typeid :'4', 
                                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy),  res - > '+  res
                                                                        });

                                                                    if(res == true){

                                                                        this.$store.dispatch('Logging',{
                                                                            appid : '2',
                                                                            typeid :'4', 
                                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                                        });


                                                                        window.location.href = this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                                    }else{

                                                                        this.$store.dispatch('Logging',{
                                                                            appid : '2',
                                                                            typeid :'4', 
                                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  res
                                                                        });

                                                                        this.$q.loading.hide()
                                                                        this.$q.dialog({
                                                                            title : 'Message',
                                                                            message : 'Something went wrong. ' + res 
                                                                        })
                                                                    } 
                                                                    
                                                                })  
                                                            } 
                                                    })

                                                //console.log('triggerAccountCreation')
                                               // console.log(res)

                                               
                                           /*  }else{
                                                this.$q.loading.hide()
                                                this.$q.dialog({
                                                    title : 'Message',
                                                    message : 'Something went wrong. ' + res 
                                                })
                                            } */
                                        /* }) */
                                    }else if(res === -1){
                                        this.$q.loading.hide()
                                        this.$q.dialog({
                                            title : 'Message',
                                            message : 'Something went wrong. Onboarding API is not responding.'  
                                        })
                                    }else{
                                        this.$q.loading.hide()
                                        this.$q.dialog({
                                            title : 'Error',
                                            message : res  
                                        })
                                    } 
                                })   

                            }else if(res=== false){
                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' Onboard Confirmation,  onboard message - > '+  this.StoreStateAOD.onboardMessage
                                });

                                this.$q.loading.hide()
                                this.$q.dialog({
                                    title : 'Warning',
                                    message :this.StoreStateAOD.onboardMessage+ ", May retry by clicking OK and ADD To Cart Again"
                                })
                            }else if(res === -1){
                                 /*    this.TriggerAccountCreation().then(res =>{
                                            
                                    this.$store.dispatch('Logging',{
                                        appid : '2',
                                        typeid :'4', 
                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerAccountCreation (buy),  res - > '+  res
                                    }); */ 
                                    /* if(res == true){  */
                                    this.StoreStateT.AgentDetails_onboard ="RZ00000"
                                    this.StoreStateT.AgentDetails ="RZ00000"
                                                if((this.TransactionId === 0)||(this.TransactionId==='')){
                                                    this.CreateTempId();
                                                }
                                                this.StoreStateCD.Transaction.Investment = []
                                                this.StoreStateCD.Account.AccountId = this.StoreStateAOD.OnBoardUTAccountNo
                                                this.CreateFundTransaction_Investment();
                                                this.PostTransaction({
                                                    ApplicationId : this.TransactionId 
                                                })
                                                .then(res=>{
                                                    this.$store.dispatch('Logging',{
                                                        appid : '2',
                                                        typeid :'4', 
                                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction (buy),  res - > '+  res
                                                    });
                                                        if(res!=true){
                                                        this.$q.loading.hide()
                                                        this.$q.dialog({
                                                            title: 'Error',
                                                            message: res,
                                                        })     
                                                        }else{
                                                          this.eMISTransactionConfirm({
                                                                DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                                                            }).then(res =>{
                                                                        this.$store.dispatch('Logging',{
                                                                            appid : '2',
                                                                            typeid :'4', 
                                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy),  res - > '+  res
                                                                        });

                                                                if(res == true){
                                                                     this.$store.dispatch('Logging',{
                                                                            appid : '2',
                                                                            typeid :'4', 
                                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                                        });


                                                                    window.location.href = this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                                                    
                                                                }else{     
                                                                    
                                                                this.$store.dispatch('Logging',{
                                                                        appid : '2',
                                                                        typeid :'4', 
                                                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  res
                                                                    });


                                                                this.$q.loading.hide()
                                                                    this.$q.dialog({
                                                                    title : 'Message',
                                                                    message : 'Something went wrong. ' + res 
                                                                    })
                                                                } 
                                                                
                                                            })   
                                                        } 
                                                })
                                              
                                  /*   }else{
                                        this.$q.loading.hide()
                                        this.$q.dialog({
                                            title : 'Message',
                                            message : 'Something went wrong. ' + res 
                                        })
                                    } 
                                })*/
                            }
                            else{
                                this.$q.loading.hide()
                                this.$q.dialog({
                                    title : 'Warning',
                                    message : res
                                })
                            }
                        })
                    
                }else{
                      /* this.TriggerAccountCreation().then(res =>{
                                            
                        this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TriggerAccountCreation (buy),  res - > '+  res
                        }); */
                        /* if(res == true){  */
                                    this.StoreStateT.AgentDetails_onboard ="RZ00000"
                                    if((this.TransactionId === 0)||(this.TransactionId==='')){

                                        this.CreateTempId();
                                    }
                                    this.StoreStateCD.Transaction.Investment = []
                                    this.StoreStateCD.Account.AccountId = this.StoreStateAOD.OnBoardUTAccountNo
                                    this.CreateFundTransaction_Investment();
                                    this.PostTransaction({
                                        ApplicationId : this.TransactionId 
                                    })
                                    .then(res=>{
                                         this.$store.dispatch('Logging',{
                                            appid : '2',
                                            typeid :'4', 
                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction (buy),  res - > '+  res
                                        });
                                        if(res!=true){
                                        this.$q.loading.hide()
                                        this.$q.dialog({
                                            title: 'Error',
                                            message: res,
                                        })     
                                        }else{
                                             this.eMISTransactionConfirm({
                                                DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                                            }).then(res =>{
                                                this.$store.dispatch('Logging',{
                                                    appid : '2',
                                                    typeid :'4', 
                                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy),  res - > '+  res
                                                });
                                                    
                                                    if(res == true){

                                                        this.$store.dispatch('Logging',{
                                                            appid : '2',
                                                            typeid :'4', 
                                                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                        });
                                                        
                                                    window.location.href = this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                                                    
                                                }else{

                                                this.$store.dispatch('Logging',{
                                                    appid : '2',
                                                    typeid :'4', 
                                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  res
                                                });
                                                    
                                                this.$q.loading.hide()
                                                    this.$q.dialog({
                                                    title : 'Message',
                                                    message : 'Something went wrong. ' + res 
                                                    })
                                                } 
                                                
                                            }) 
                                        } 
                                    })
                                  
                        /* }else{
                            this.$q.loading.hide()
                            this.$q.dialog({
                                title : 'Message',
                                message : 'Something went wrong. ' + res 
                            })
                        } 
                    })*/
                }
            })
           

        }else{
            
           // this.StoreStateT.AgentDetails =""
            if((this.TransactionId === 0)||(this.TransactionId==='')){

                this.CreateTempId();
            }
            
            this.CreateFundTransaction_Investment();
            this.PostTransaction({
                ApplicationId : this.TransactionId 
            })
            .then(res=>{

                    this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' PostTransaction (buy),  res - > '+  res
                    });
                    if(res!=true){
                    this.$q.loading.hide()
                    this.$q.dialog({
                        title: 'Error',
                        message: res,
                    })     
                }else{
                    var vm = this; 
                            this.eMISTransactionConfirm({
                                DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                            })
                            .then(res =>{
                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy),  res - > '+  res
                                });
                                if(res == true){

                                    this.$store.dispatch('Logging',{
                                        appid : '2',
                                        typeid :'4', 
                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID
                                    });
                                    window.location.href = this.IakaunRerouteUrl + this.StoreStateAOD.OnboardingAppID;
                                }else{
                                    this.$store.dispatch('Logging',{
                                        appid : '2',
                                        typeid :'4', 
                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirm (buy) routing,  res - > '+  res
                                    });
                                    this.$q.loading.hide()
                                    this.$q.dialog({
                                        title : 'Message',
                                        message : 'Something went wrong. ' + res 
                                    })
                                }
                            }) 
                }
                this.ConfirmTransactionModal = false;
            }) 
        }
           
        },
        
        CreateFundTransaction_Investment(){
            this.StoreStateT.Transaction.tempInvestment = []
            for(var i=0; i<this.StoreStateT.Transaction.Investment.length; i++){
                this.StoreStateT.Transaction.tempInvestment.push({
                    Amount: this.StoreStateT.Transaction.Investment[i].Amount,
                    SalesCharge:this.StoreStateT.Transaction.Investment[i].SalesCharge,
                    Scheme:this.StoreStateT.Transaction.Investment[i].Scheme,
                    SchemeName:this.StoreStateT.Transaction.Investment[i].SchemeName
                })
            }
            this.StoreStateCD.Transaction.Investment = [] /// to reset draft array if DRAFT call fail
            for(var j=0; j<this.StoreStateT.Transaction.tempInvestment.length; j++){
                this.StoreStateCD.Transaction.Investment.push({
                    Id: this.TransactionId,
                    Amount : this.StoreStateT.Transaction.tempInvestment[j].Amount,
                    SalesCharge : this.StoreStateT.Transaction.tempInvestment[j].SalesCharge,
                    SmartSave : this.StoreStateT.Transaction.tempInvestment[j].SmartSave,
                    ModeOfFrequency : this.StoreStateT.Transaction.tempInvestment[j].ModeOfFrequency,
                    DateOfDeduction : this.StoreStateT.Transaction.tempInvestment[j].DateOfDeduction,
                    FundID : this.StoreStateT.Transaction.tempInvestment[j].Scheme,
                    FundName : this.StoreStateT.Transaction.tempInvestment[j].SchemeName,
                    Plan : 'EPF',
                    FundCurrency : 'MYR',
                    TypeOfProduct : 'UTF'
                })
            }

            this.$store.dispatch('Logging',{
                appid : '2',
                typeid :'4', 
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' CreateFundTransaction_Investment (buy),  this.StoreStateCD.Transaction.Investment - > '+  this.StoreStateCD.Transaction.Investment.length +' Trx id ->' + this.TransactionId
            });
         
        },
         CreateTempId() {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c=='x' ? r :(r&0x3|0x8)).toString(16);
            });
            this.TransactionId =  uuid;
        },
    },
    mounted(){ 
          // this.$q.loading.hide() 
    },
    filters: {
        thousandSeparator: function(value) {
            if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return value;
            }
        }
    }
}
</script>